'use strict'

import axios from 'axios'

const { VUE_APP_COMMS_URL } = process.env

export default async ({ messageId, type, jwt }) => axios({
  method: 'delete',
  headers: {
    Authorization: jwt
  },
  url: `${VUE_APP_COMMS_URL}/${type}/${messageId}`,
  timeout: 8000
})
